var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 25,
    viewBox: "0 0 83 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M0.357705 24.459V0.0714421H15.8031V1.62659H2.05423V10.7454H14.7428V12.3006H2.05423V22.9038H15.8031V24.459H0.357705ZM20.5757 24.459V6.25669H30.2247C33.5706 6.25669 35.2436 7.94143 35.2436 11.3109V24.459H33.6531V10.9575C33.6531 8.76613 32.5574 7.67046 30.3661 7.67046H22.1662V24.459H20.5757ZM40.9713 19.4048V0.0714421H42.5618V6.25669H49.666V7.67046H42.5618V19.7582C42.5618 21.9495 43.6575 23.0452 45.8488 23.0452H50.0194V23.7168L49.0298 24.459H46.0255C42.656 24.459 40.9713 22.7742 40.9713 19.4048ZM54.015 19.4048V11.3109C54.015 7.94143 55.6997 6.25669 59.0692 6.25669H63.664C67.0099 6.25669 68.6829 7.94143 68.6829 11.3109V16.0117H55.6055V19.7582C55.6055 21.9495 56.7012 23.0452 58.8925 23.0452H67.976V23.7168L66.9863 24.459H59.0692C55.6997 24.459 54.015 22.7742 54.015 19.4048ZM55.6055 14.5979H67.0924V10.9575C67.0924 8.76613 65.9967 7.67046 63.8053 7.67046H58.8925C56.7012 7.67046 55.6055 8.76613 55.6055 10.9575V14.5979ZM74.2791 24.459V8.20062C75.0803 6.90467 76.5294 6.25669 78.6265 6.25669H81.9842L82.9738 6.99892V7.67046H78.4497C77.2716 7.67046 76.4116 7.98856 75.8696 8.62475V24.459H74.2791Z",
    fill: "url(#paint0_linear_1378_1024)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1378_1024",
    x1: -1.6618,
    y1: 3.15928,
    x2: 20.2284,
    y2: 4.01476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758716,
    stopColor: "#BFFFD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFFFD9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnter);
export default __webpack_public_path__ + "static/media/Enter.a94ce48e06e2ad0baff1a2fc42cc04b6.svg";
export { ForwardRef as ReactComponent };